


const API_ASSIGNMENT_REQUEST_REQUEST = 'API_ASSIGNMENT_REQUEST_REQUEST';
const API_ASSIGNMENT_REQUEST_SUCCESS = 'API_ASSIGNMENT_REQUEST_SUCCESS';
const API_ASSIGNMENT_REQUEST_FAILURE = 'API_ASSIGNMENT_REQUEST_FAILURE';





export const assignmentRequestRequest = payload => ({
  type: API_ASSIGNMENT_REQUEST_REQUEST,
  payload: payload
});

export const assignmentRequestSuccess = payload => ({
  type: API_ASSIGNMENT_REQUEST_SUCCESS,
  payload,
});

export const assignmentRequestFailure = payload => ({
  type: API_ASSIGNMENT_REQUEST_FAILURE,
  payload,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  assignmentRequestType: null,
  retakeMesssage:null
};

export function assignmentRequest(state = initialState, action) {
 
  switch (action.type) {
    case API_ASSIGNMENT_REQUEST_REQUEST:
    
   if(action.payload=='retake' || action.payload=='extension'){
    return {
      ...state,
      fetching: true,
      assignmentRequestType: action.payload
    };
   }
     
    case API_ASSIGNMENT_REQUEST_SUCCESS:
    
      return {
        ...state,
        error: null,
        fetching: false,
        isFetched: true,
        retakeMesssage: action.payload
      };
    case API_ASSIGNMENT_REQUEST_FAILURE:
    
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/assignmentRequest.js